module.exports = __webpack_public_path__ + "img/world_map.841414c4.png";